export default __webpack_public_path__ + "static/SR USA - Food Grade - Statement-a4a755ae45669e417d64e7d1cac83a77.pdf";